<template>
  <div>
    <p>Препарат: <strong>{{ task.task_data?.drug?.title }}</strong></p>
    <p>{{ task.task_data?.drug?.group }}</p>
    <p v-if="task.task_data?.comment">{{ task.task_data.comment }}</p>
    <div class="row mt-2">
      <div class="col-md-4" v-for="(code, alias) in codes">
        <div class="flex justify-content-between">
          <span>{{ code.title }}</span>
          <button @click="addCode(alias)" class="ml-1 btn btn-xs btn-default">добавить</button>
        </div>
        <div v-for="(d, i) in code.codes" class="flex mt-1">
          <input v-model="d.text" type="text" class="form-control">
          <button @click="removeCode(alias, i)" class="btn btn-default" type="button"><i
            class="icon-fa icon-fa-remove"/>
          </button>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <CommentsBlock :task="task" :updateTasks="updateTasks"/>
    </div>
    <div class="mt-2 text-right mb-1">
      <div class="flex flex_gap_10 justify-content-end">
        <LoadingButton
          title="Создать задачу"
          :loading="loading"
          color="white"
          :onClick="() => saveTask()"
          className="btn btn-outline-success"
        />
        <LoadingButton
          title="Сохранить изменения"
          :loading="loading"
          color="white"
          :onClick="() => saveTask()"
          className="btn btn-success"
        />
      </div>
    </div>
  </div>
</template>

<script>

import CommentsBlock from "../components/CommentsBlock.vue"
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import {customUpdateData} from "@/eventsBus";

export default {
  components: {LoadingButton, CommentsBlock},
  props: ['task', 'updateTasks'],
  data() {
    return {
      loading: false,
      details: {},
      codes: {
        uteka: {title: 'ID для UTEKA', codes: []},
        eapteka: {title: 'ID для EAPTEKA', codes: []},
        aptekamos: {title: 'Линк для APTEKAMOS', codes: []},
      }
    }
  },
  created() {
    this.getDrugDetails();
  },
  methods: {
    async getDrugDetails() {
      const {data} = await api.index('/new/drugs/candidate/details/' + this.task.object_id);
      if (data.success) {
        this.details = data.details.reduce((acc, d) => {
          if (!acc[d.group]) acc[d.group] = {};
          if (!acc[d.group][d.alias]) acc[d.group][d.alias] = [];
          acc[d.group][d.alias].push(d);
          return acc;
        }, {});

        Object.keys(this.codes).forEach((a) => {
          if (this.details?.suppliers_link_data?.[a]) {
            this.details.suppliers_link_data[a].forEach((d) => {
              this.addCode(a, d.value);
            })
          } else {
            this.addCode(a);
          }
        })
      }
    },
    async saveTask() {
      this.loading = true;
      const {data} = await api.post('/new/drugs/candidate', {
        action: 'updateSupplierLinksData',
        record_id: this.task.object_id,
        codes: this.codes
      })
      if (data.success) {
        console.log('update');
        customUpdateData.$emit(
          'updateMSPairedDrugs', {}
        );
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    },
    removeCode(alias, index) {
      delete this.codes[alias].codes[index];
      this.codes[alias].codes = this.codes[alias].codes.filter((c) => c);
      if (!this.codes[alias].codes.length) {
        this.addCode(alias);
      }
    },
    addCode(alias, text = '') {
      this.codes[alias].codes.push({text});
    }
  }
}

</script>
